/**
 * Constants for Notifications Page feature
 *
 * These are Panther string identifiers, not display text. Resolve them through
 * `t(bundle, id)` from '@src/translationHelper' — the English source lives in
 * resources/translations.puff.json.
 */

// Tool Name
export const NOTIFICATIONS_TOOL_NAME = 'jsma-web-notifications-toolName'

// UI Text
export const JUST_NOW = 'jsma-web-notifications-justNow'
export const MINUTES_AGO = 'jsma-web-notifications-minutesAgo'
export const HOURS_AGO = 'jsma-web-notifications-hoursAgo'
export const YESTERDAY = 'jsma-web-notifications-yesterday'
export const DAYS_AGO = 'jsma-web-notifications-daysAgo'
export const VIEW_DETAILS = 'jsma-web-notifications-viewDetails'
export const ALL_OTHER_STORES = 'jsma-web-notifications-allOtherStores'
export const CURRENT_STORE = 'jsma-web-notifications-currentStore'
export const ALL_STORES = 'jsma-web-notifications-allStores'
export const PENDING_TASKS = 'jsma-web-notifications-pendingTasks'
export const STORE_SELECTION_SUMMARY = 'jsma-web-notifications-storeSelectionSummary'
export const LOADING_NOTIFICATIONS = 'jsma-web-notifications-loading'
export const UNABLE_TO_LOAD_ERROR = 'jsma-web-notifications-loadError'
export const VIEW_ONLY_TITLE = 'jsma-web-notifications-viewOnlyTitle'
export const VIEW_ONLY_MESSAGE = 'jsma-web-notifications-viewOnlyMessage'
export const NOTIFICATION_ICON_ALT = 'jsma-web-notifications-notificationIconAlt'
export const STORE_ICON_ALT = 'jsma-web-notifications-storeIconAlt'

// Empty State Messages
export const EMPTY_STATE_NO_NOTIFICATIONS = 'jsma-web-notifications-emptyNoNotifications'
export const EMPTY_STATE_ALL_CAUGHT_UP = 'jsma-web-notifications-emptyAllCaughtUp'
export const EMPTY_STATE_DEFAULT = 'jsma-web-notifications-emptyDefault'

// Store Filter
export const FILTER_NOTIFICATIONS_HEADING = 'jsma-web-notifications-filterHeading'
export const APPLY_FILTERS_LABEL = 'jsma-web-notifications-applyFilters'
export const CLEAR_FILTER = 'jsma-web-notifications-clearFilter'
// Shared with the store selection page so both search boxes read the same.
export { SEARCH_PLACEHOLDER as SEARCH_STORES_PLACEHOLDER } from '@pages/StoreSelectionPage/constants'
